export const CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID = 'contratos_proximos_a_vencer'
export const RECURSOS_HUMANOS_CATEGORY_ID = 'recursos_humanos'

export { defaultConfiguracionEquipoAccess as defaultContratosProximosAVencerAccess } from './configuracionEquipoModule'
